module.exports = __webpack_public_path__ + "img/OPINFO-NH-2704.b05666b8.jpg";